import React from 'react';

/**
 * Thumbs Selector Component
 * 
 * Simple thumbs up/down feedback for agreement with displayed risk grade/decision
 * Thumbs up = Agree, Thumbs down = Disagree
 */
const ThumbsSelector = ({ value, onChange, required = false }) => {
  return (
    <div className="thumbs-selector">
      <div className="thumbs-buttons">
        <button
          className={`thumb-button thumb-up ${value === 'agree' ? 'selected' : ''}`}
          onClick={() => onChange(value === 'agree' ? null : 'agree')}
          title="Agree"
          type="button"
        >
          👍
        </button>
        <button
          className={`thumb-button thumb-down ${value === 'disagree' ? 'selected' : ''}`}
          onClick={() => onChange(value === 'disagree' ? null : 'disagree')}
          title="Disagree"
          type="button"
        >
          👎
        </button>
      </div>
      {required && !value && (
        <div className="thumbs-required-hint">* Required</div>
      )}
    </div>
  );
};

export default ThumbsSelector;
